<template>
  <div v-cloak>
    <HoverShowButton
      :always-show="forceShowBtn"
      :btn-text="forceShowBtn ? $t('Add') : $t('Edit')"
      @clicked="open"
    >
      <slot v-if="persistedPoNumber" :po-number="persistedPoNumber">
        {{ persistedPoNumber }}
      </slot>
    </HoverShowButton>

    <!-- eslint-disable-next-line vue/no-undef-components -- Baseline eslint ignore please fix if working on this-->
    <BaseModal
      v-cloak
      :modal-id="`bill-${billId}`"
      :header-text="$t('Purchase order number')"
      :save-state="saveState"
      :is-open="modalOpen"
      @save="update"
      @cancel="close"
    >
      <div class="p-t-15 p-b-15">
        <input
          v-model="poNumberState"
          :disabled="$apollo.loading"
          :placeholder="$t('Enter PO number')"
          title="Your purchase order number for the bill'"
          class="form-control tt-input"
        />
      </div>
    </BaseModal>
  </div>
</template>

<script>
import gql from 'graphql-tag'
import HoverShowButton from '@/components/HoverShowButton.vue'

export default {
  components: { HoverShowButton },
  props: {
    billId: { type: [Number, String], required: true },
    poNumber: { type: String, default: '' },
    alwaysShowBtn: { type: Boolean, default: false },
    showBtnWhenEmpty: { type: Boolean, default: false },
  },
  data() {
    return {
      modalOpen: false,
      poNumberState: this.getInitialPoNumber(),
      persistedPoNumber: this.getInitialPoNumber(),
      saveState: 'fresh',
      hasSaved: false,
    }
  },
  computed: {
    forceShowBtn() {
      // Either by props, or by a null value (unless it's still loading)
      if (this.showBtnWhenEmpty && !this.persistedPoNumber && !this.$apollo.loading) {
        return true
      }
      return this.alwaysShowBtn
    },
  },
  watch: {
    persistedPoNumber(newValue, oldValue) {
      if (newValue !== this.poNumberState) {
        this.poNumberState = newValue
      }
    },
  },
  methods: {
    open() {
      this.modalOpen = false
      this.modalOpen = true
      // store for reverting
      this.hasSaved = false
    },
    close() {
      this.modalOpen = false
    },
    getInitialPoNumber() {
      return this.poNumber || ''
    },
    update() {
      this.saveState = 'saving'
      this.$apollo
        .mutate({
          mutation: gql`
            mutation ($billId: Int!, $poNumber: String!) {
              updateBill(input: { localId: $billId, poNumber: $poNumber }) {
                globalId
                poNumber
              }
            }
          `,
          variables: { billId: this.billId, poNumber: this.poNumberState },
        })
        .then((data) => {
          this.hasSaved = true
          this.saveState = 'saved'
          if (
            data.hasOwnProperty('data') &&
            data.data.hasOwnProperty('updateBill') &&
            data.data.updateBill.hasOwnProperty('poNumber')
          ) {
            this.persistedPoNumber = data.data.updateBill.poNumber
          }
          this.$emit('updated', this.poNumberState)
          setTimeout(() => {
            this.close()
          }, 1000)
        })
        .catch((error) => {
          this.saveState = 'failed'
        })
        .finally(() => {
          setTimeout(() => {
            this.saveState = 'fresh'
          }, 1000)
        })
    },
  },
  apollo: {
    persistedPoNumber: {
      query: gql`
        query me($billId: Int!) {
          me {
            activeAccount {
              bill(localId: $billId) {
                globalId
                poNumber
              }
            }
          }
        }
      `,
      update: (data) => data.me.activeAccount.bill.poNumber,
      variables() {
        return { billId: this.billId }
      },
      // Disable the query initially
      skip() {
        return Boolean(this.poNumber) || true
      },
    },
  },
}
</script>
